(
    ($) => {
        $(document).ready(function () {
                const body = $('body');
                const wrapper = $('#menu-list').clone();
                const mainUl = wrapper.find('.main-menu-list');
                const closeBtn = $('<button class="mobile-close-btn"><i class="icon-close1"></i></button>');
                let MenuCreated = true;

                function mobileMenuFun() {
                    if ($(window).outerWidth() < 768) {
                        if (body.find('.main-menu-list--mobile').length) {
                            return;
                        }
                        body.append(wrapper);

                        if (MenuCreated) {
                            wrapper.prepend(closeBtn);
                            wrapper.addClass('main-menu-list--mobile');

                            mainUl.attr('id', IdGenerator());
                            const menu = wrapper.find('.main-menu-list li');
                            menu.each(function (index, child) {
                                if ($(child).children("ul").length) {
                                    const id = IdGenerator();
                                    $(child).find('> a').attr('data-target', '#' + id);
                                    const ulChild = $(child).children('ul');
                                    const back = $('<li><button class="back"><i class="icon-arrow-left"></i><div class="ul-title"></div></button></li>');
                                    back.find('.ul-title').text($(child).find('> a').html());
                                    ulChild.prepend(back);
                                    $(ulChild).addClass('main-menu-list').attr('id', id);
                                    wrapper.append(ulChild);
                                    $(child).find('> a').append('<i class="icon-arrow-right"></i>')
                                }
                            });
                            mainUl.addClass('open');
                            backAttr();
                            MenuCreated = false;
                        }
                    } else {
                        $('body').find(wrapper).remove();
                    }

                    $(wrapper).find('a').on('click', function (e) {
                        const _tab = $(this);
                        if (_tab.parent().hasClass('has-dropdown')) {
                            e.preventDefault();
                        }
                        $(wrapper).find('.main-menu-list').removeClass('open');
                        const el = $(_tab.attr('data-target'));
                        setTimeout(function () {
                            el.addClass('open');
                        }, 200);
                    });

                    $(wrapper).find('.back').on('click', function () {
                        const _tab = $(this);
                        console.log($(wrapper).find('.main-menu-list'));
                        $(wrapper).find('.main-menu-list').removeClass('open');
                        const id = _tab.attr('data-target');
                        const el = $('[id="' + id + '"]');
                        setTimeout(function () {
                            el.addClass('open');
                        }, 200);
                    });
                }

                function backAttr() {
                    const back = wrapper.find('.back');
                    back.each(function (index, el) {
                        const id = $(el).parents('ul').attr('id');
                        const parentId = $(wrapper).find('[data-target="#' + id + '"]').closest('[id]').attr('id');
                        $(el).attr('data-target', parentId);
                    });
                }


                const mobileBtn = $('.burger');
                mobileBtn.on('click', function () {
                    if (!$(mobileBtn).hasClass('open')) {
                        $(mobileBtn).addClass('open');
                        $('body').css('overflow', 'hidden');
                        wrapper.css('display', 'block');
                        setTimeout(function () {
                            wrapper.addClass('open');
                        }, 100)
                    }
                });

                closeBtn.on('click', function () {
                    $(wrapper).find('.main-menu-list.open').removeClass('open');
                    mainUl.addClass('open');
                    wrapper.removeClass('open');
                    setTimeout(function () {
                        wrapper.css('display', 'none');
                    }, 200)
                    $(mobileBtn).removeClass('open');
                    $('body').removeAttr('style');
                });


                /**
                 * @return {string}
                 */
                function IdGenerator() {
                    return (((1 + Math.random()) * 0x1000000) | 0).toString(16).substring(1);
                }


                mobileMenuFun();

                $(window).on('resize', function () {
                    mobileMenuFun();
                });
            }
        );
    }
)(jQuery);
